<template>
<div class="chapter">
<div class="inner_page">
<p class="dedic" id="ch00_fm05_dedi"><a id="page_v"></a><em>For Juliet,<br/>and in memory of Mark Edwin Sitton, 1974–1998</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_dedi.vue?41d4c18a